import React, { Component } from 'react';
import autobind from 'class-autobind';

import GridTileForDesktop from './grid_tile_for_desktop.jsx';
import ConditionalLinkFromTile from './conditional_link_from_tile.jsx';

class GrdiTileForDesktopWrappedWithLink extends Component {

  constructor(props) {
    super(props);
    autobind(this);
  }

  render() {
    const {
      wrappedLinkTarget,
      wrappedLinkHref,
      onLinkToVideoClick,
      ...tile
    } = this.props;

    return (
      <ConditionalLinkFromTile 
        key={tile.uuid || tile.eid} 
        linkTarget={wrappedLinkTarget} 
        linkHref={wrappedLinkHref}
        doesTileLinkToVideo={this.props.doesTileLinkToVideo}
        onLinkToVideoClick={onLinkToVideoClick}
      >
        <GridTileForDesktop
          {...tile}
          tileLinkTarget={wrappedLinkTarget} 
          tileLinkHref={wrappedLinkHref}
          doesTileLinkToVideo={this.props.doesTileLinkToVideo}
          onLinkToVideoClick={onLinkToVideoClick}
        />
      </ConditionalLinkFromTile>
    );
  }

}

export default GrdiTileForDesktopWrappedWithLink;
